import { IthHelmet, ThEmpty } from "@/components"
import {
    getAuditTypeInfo,
    getHistories,
    getWorktimeDailyApi,
    updateTimeworks,
    auditTimeworks,
    auditTimeworksSz,
    getWorktimeDailyNewApi,
} from "@/services/apis/worktimeDaily"
import { useRequest } from "ahooks"
import {
    Breadcrumb,
    Button,
    Card,
    Pagination,
    Radio,
    RadioChangeEvent,
    Spin,
    Tooltip,
} from "antd"
import clsx from "clsx"
import useQueryParams, { k_pageType } from "./hook"
import { useEffect, useMemo, useState, useRef } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { LoadingOutlined, InfoCircleOutlined } from "@ant-design/icons"
import styles from "../worktime.module.scss"
import { addMultiple } from "@/utils/amount"
import type { RenderProjectTableData, RenderMajorTableData } from "../worktime"
import AuditInfoContent from "./auditInfo"
import OldAuditInfo from "../components/oldAuditInfo"

const defaultParams = {
    userIds: [],
    keyword: "",
}



const Index = () => {
    const { currentDate, pageType } = useQueryParams()

    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)

    const [selectedDate, setSelectedDate] = useState(currentDate)

    const navigate = useNavigate()


    const {
        data: historys,
        loading: historyLoading,
        run: runGetHistories,
        refresh: refreshHistories,
        params: [searchParams = { ...defaultParams, type: pageType }],
    } = useRequest(getHistories, {
        defaultParams: [{ ...defaultParams, page, pageSize, type: pageType }],
        onSuccess: (res) => {
            if (res.list && res.list.length > 0) {
                let firstDate = ""
                if (!selectedDate) {
                    firstDate = res.list[0].firstDate
                } else {
                    let allDates: string[] = []
                    res.list.forEach(v => {
                        allDates = [...allDates, ...v.dates]
                    })
                    if (!allDates.includes(selectedDate)) {
                        firstDate = res.list[0].firstDate
                    } else {
                        return
                    }
                }
                setSelectedDate(firstDate)
                if (firstDate !== currentDate) {
                    const searchParams = new URLSearchParams(window.location.search)
                    searchParams.delete("currentDate")
                    navigate({ search: searchParams.toString() }, { replace: true })
                }
                // const searchParams = new URLSearchParams(window.location.search)
                // navigate({ search: searchParams.toString() }, { replace: true })
            }
        },
    })

    const { data: auditTypeInfo, refresh } = useRequest(getAuditTypeInfo, {
        defaultParams: [],
        onSuccess: (d) => {
            if (!d.hasZc && d.hasSz && pageType === k_pageType.zc) {
                const searchParams = new URLSearchParams(window.location.search)
                searchParams.set("pageType", k_pageType.sz)
                searchParams.delete("currentDate")
                searchParams.delete("all")
                navigate({ search: searchParams.toString() }, { replace: true })
            } else if (!d.hasSz && d.hasZc && pageType === k_pageType.sz) {
                const searchParams = new URLSearchParams(window.location.search)
                searchParams.set("pageType", k_pageType.zc)
                searchParams.delete("currentDate")
                searchParams.delete("all")
                navigate({ search: searchParams.toString() }, { replace: true })
            }
        }
    })


    const onPageChange = (v: number) => {
        setPage(v)
        runGetHistories({ ...searchParams, type: pageType, page: v, pageSize })
    }

    useEffect(() => {
        if (!pageType) return
        setSelectedDate("")
        runGetHistories({ ...searchParams, type: pageType, page, pageSize })
    }, [pageType])

    const onExpand = (item: API.WorktimeDaily.weekday) => {
        setSelectedDate(item.firstDate)
    }


    const handleChangeType = (type: RadioChangeEvent) => {
        const searchParams = new URLSearchParams(window.location.search)
        searchParams.set("pageType", type.target.value)
        searchParams.delete("currentDate")
        searchParams.delete("all")
        setPage(1)
        navigate({ search: searchParams.toString() }, { replace: true })
    }

    const hasUpdateStatus = (v: API.WorktimeDaily.weekday) => {
        let status = -1
        if (pageType === k_pageType.sz) {
            status = v.paStatus
        } else if (pageType === k_pageType.zc) {
            status = v.status
        }
        return status === 2
    }

    const listItemStatus = (v: API.WorktimeDaily.weekday) => {
        if(historyLoading) return <></>
        let status = -1
        let dates: string[] = []
        if (pageType === k_pageType.sz) {
            status = v.paStatus
            dates = v.noPaDates || []
        } else if (pageType === k_pageType.zc) {
            status = v.status
            dates = v.noDates || []
        }

        switch (status) {
            case 0:
                return <span className="text-red-700">未审批</span>
            case 1:
                return <span className="text-gray-400">已审批</span>
            case 2:
                return (
                    <span className="text-red-400 flex flex-wrap gap-2">
                        {dates.length > 0 ? (
                            <span className="flex flex-wrap items-center gap-1">
                                {dates.map((item) => (
                                    <span key={item} className="">{item}</span>
                                ))}
                                <span className="ml-0">未审</span>
                            </span>
                        ) : ""}
                        {v.updateDates.length > 0 ? (
                            <span className="flex flex-wrap items-center gap-1">
                                {v.updateDates.map((item) => (
                                    <span key={item} className="">{item}</span>
                                ))}
                                <span className="ml-0">更新</span>
                            </span>
                        ) : ""}
                    </span>
                )
        }
        return <></>
    }


    return (
        <Spin spinning={historyLoading}>
            <div className="flex bg-white p-2 h-[calc(100vh-140px)] relative overflow-hidden">
                <div className="shrink-0 pr-2 h-full flex flex-col overflow-hidden max-w-[400px]">
                    <div className="shrink-0">
                        {(auditTypeInfo?.hasZc || auditTypeInfo?.hasSz) && (
                            <div className="mb-6 flex justify-start gap-4 items-center">
                                <Radio.Group onChange={handleChangeType} value={pageType}>
                                    {auditTypeInfo?.hasZc && (
                                        <Radio.Button value="zc">
                                            专负{auditTypeInfo.zcCount > 0 && `(${auditTypeInfo.zcCount})`}
                                        </Radio.Button>
                                    )}
                                    {auditTypeInfo?.hasSz && (
                                        <Radio.Button value="sz">
                                            设总{auditTypeInfo.szCount > 0 && `(${auditTypeInfo.szCount})`}
                                        </Radio.Button>
                                    )}
                                </Radio.Group>

                                <Breadcrumb
                                    items={[
                                        { key: "detail", title: "工时审核" },
                                    ]}
                                />
                            </div>
                        )}

                        <IthHelmet pageTitle="工时审批" report />
                    </div>
                    <div className="flex-1 overflow-y-auto relative">
                        {!historyLoading && (!historys || historys.list.length <= 0) ? (
                            <div className="mt-8">
                                <ThEmpty
                                    description={
                                        <div className="text-black/50 mt-4">暂无审批数据</div>
                                    }
                                />
                            </div>
                        ) : (
                            <>
                                {historys &&
                                    historys.list?.map((v) => (
                                        <Card
                                            key={v.subject}
                                            className={clsx("mb-4 cursor-pointer", {
                                                'border-blue-300 border-2 bg-blue-100': selectedDate === v.firstDate
                                            })}
                                            onClick={() => onExpand(v)}
                                        >
                                            <div className="flex items-center justify-between">
                                                <div className="text-gray-700 font-bold flex items-center gap-12">
                                                    <div>期间 {v.subject}</div>
                                                </div>
                                                {!hasUpdateStatus(v) && (
                                                    <div className="ml-2">
                                                        {listItemStatus(v)}
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                {hasUpdateStatus(v) && (
                                                    <div className="">
                                                        {listItemStatus(v)}
                                                    </div>
                                                )}
                                                {v.weekDayReminder && (
                                                    <span className="text-red-400 text-xs mr-2">今天需要把该周工时审批完成</span>
                                                )}
                                            </div>
                                        </Card>
                                    ))}
                                <Card>
                                    <Pagination
                                        current={page}
                                        total={historys?.total}
                                        pageSize={pageSize}
                                        onChange={(v) => onPageChange(v)}
                                    />
                                </Card>
                            </>
                        )}
                    </div>
                    
                    
                </div>
                <div className="flex-1 border-l border-gray-200 pl-2 overflow-hidden relative">
                    {pageType === k_pageType.zc && (
                        <OldAuditInfo
                            defaultDate={selectedDate || ""}
                            pageType={pageType || k_pageType.zc}
                            onUpdateList={refreshHistories}
                        />
                    )}
                    {pageType === k_pageType.sz && (
                        <AuditInfoContent
                            defaultDate={selectedDate || ""}
                            pageType={pageType || k_pageType.zc}
                            onUpdateList={refreshHistories}
                        />
                    )}
                </div>
            </div>
            
        </Spin>
    )
}

export default Index